import React, { useState } from "react";
import { useNavigate } from "react-router";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";

function PricingBody() {
  //purchasable items
  //items
  const [itemsState, setItemsState] = useState({
    items: [
      {
        item_name: "Basic",
        item_description: "for basic users (recommended for students)",
        item_price: 4.99, //in dollar $
        item_fake_price: 9.99, //price without discount
        validity: "Lifetime",
      },
      {
        item_name: "PRO",
        item_description: "for professional users (for corporate people)",
        item_price: 19.99, //in dollar $
        item_fake_price: 59.99, //price without discount
        validity: "Lifetime",
      },
      {
        item_name: "Enterprise",
        item_description: "for business users",
        item_price: 159.99, //in dollar $
        item_fake_price: 249.99, //price without discount
        validity: "Lifetime",
      },
    ],
    selected_index: 1,
  });

  //react router navigate
  const navigate = useNavigate(); //react router navigate

  return (
    <div className="container text-center">
      {/* heading */}
      <div>
        <h1 className="display-6">
          Simple Pricing for Smarter and <br />
          More Human Texts
        </h1>
        <p className="lead mt-3">
          Many people are upgrading to the premium version to convert their
          AI-generated contents into human-written contents.
        </p>
      </div>

      {/* Plans*/}
      <div className="row align-items-end" style={{ marginTop: "7rem" }}>
        {/* Basic Plan */}
        <div className="col col-lg-4 col-sm-12 mt-2">
          <div
            className={`card shadow ${
              itemsState.selected_index === 0 ? "border-danger" : ""
            }`}
          >
            {/* Header */}
            <div className="card-header text-center text-dark d-none"> </div>
            <div className="card-body">
              {/* heading */}
              <h2 className="card-title text-danger">
                {itemsState.items[0].item_name}
              </h2>
              <p className="card-text text-muted">
                {itemsState.items[0].item_description}
              </p>

              {/* Price */}
              <div>
                <h1>
                  ${itemsState.items[0].item_price}{" "}
                  <label className="d-inline fs-5">Lifetime</label>
                </h1>
                <h5 className="text-danger text-decoration-line-through">
                  ${itemsState.items[0].item_fake_price}
                </h5>
                <p className="lead fs-5">1,00,000 characters</p>
              </div>

              {/* Features List */}
              <ul
                className="list-group list-group-flush bg-white"
                style={{ marginTop: "3rem" }}
              >
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Lifetime free
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Process total 1,00,000 (chars)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Words limit 2000 (at a time)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Fast response time
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  No Advertisements
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  AI detection (Text + Image)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  AI to Humanizer
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Paraphrase Texts
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Summarize Texts
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Plagiarism Checker
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Access to all premium features
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Browse History
                </li>
              </ul>

              {/* Purchase Button */}
              <div>
                <button
                  className="btn btn-primary px-5 py-2 mb-4 mt-5 rounded-pill fs-5"
                  onClick={(e) => {
                    //analytics
                    logEvent(analytics, "button_click", {
                      button_name: "purchase_basic_click",
                    });
                    //blur
                    e.target.blur();
                    //selectedƒ
                    setItemsState({ ...itemsState, selected_index: 0 });
                    //navigate to purchase page
                    navigate("/purchase", {
                      state: {
                        item: itemsState.items[0],
                      },
                    }); //Navigate to purchase page
                  }}
                >
                  Purchase
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* PRO plan */}
        <div className="col col-lg-4 col-sm-12 mt-2">
          <div
            className={`card shadow ${
              itemsState.selected_index === 1 ? "border-danger" : ""
            }`}
          >
            {/* Header */}
            <div className="card-header text-center text-dark">Popular</div>
            <div className="card-body">
              {/* heading */}
              <h2 className="card-title text-danger">
                {itemsState.items[1].item_name}
              </h2>
              <p className="card-text text-muted">
                {itemsState.items[1].item_description}
              </p>

              {/* Price 30 days*/}
              <div>
                <h1>
                  ${itemsState.items[1].item_price}{" "}
                  <label className="d-inline fs-5">Lifetime</label>
                </h1>
                <h5 className="text-danger text-decoration-line-through">
                  ${itemsState.items[1].item_fake_price}
                </h5>
                <p className="lead fs-5">6,00,000 characters</p>
              </div>

              {/* Features List */}
              <ul
                className="list-group list-group-flush bg-white"
                style={{ marginTop: "3rem" }}
              >
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Lifetime free
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Process total 6,00,000 (chars)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Words limit 5000 (at a time)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Faster response time
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  No Advertisements
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  AI detection (Text + Image)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  AI to Humanizer
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Paraphrase Texts
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Summarize Texts
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Plagiarism Checker
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Access to all premium features
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Browse History
                </li>
                <li className="list-group-item text-start ms-3 text-decoration-line-through">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  API usage
                  <span className="badge bg-secondary ms-3">Coming soon</span>
                </li>
              </ul>

              {/* Purchase Button */}
              <div>
                <button
                  className="btn btn-primary px-5 py-2 mb-4 mt-5 rounded-pill fs-5"
                  onClick={(e) => {
                    //analytics
                    logEvent(analytics, "button_click", {
                      button_name: "purchase_pro_click",
                    });
                    //blur
                    e.target.blur();
                    //selectedƒ
                    setItemsState({ ...itemsState, selected_index: 1 });
                    //navigate to purchase page
                    navigate("/purchase", {
                      state: {
                        item: itemsState.items[1],
                      },
                    }); //Navigate to purchase page
                  }}
                >
                  Purchase
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Enterprise plan */}
        <div className="col col-lg-4 col-sm-12 mt-2">
          <div
            className={`card shadow ${
              itemsState.selected_index === 2 ? "border-danger" : ""
            }`}
          >
            {/* Header */}
            <div className="card-header text-center text-dark d-none"> </div>
            <div className="card-body">
              {/* heading */}
              <h2 className="card-title text-danger">
                {itemsState.items[2].item_name}
              </h2>
              <p className="card-text text-muted">
                {" "}
                {itemsState.items[2].item_description}
              </p>

              {/* Price 365 days*/}
              <div>
                <h1>
                  ${itemsState.items[2].item_price}{" "}
                  <label className="d-inline fs-5">Lifetime</label>
                </h1>
                <h5 className="text-danger text-decoration-line-through">
                  ${itemsState.items[2].item_fake_price}
                </h5>
                <p className="lead fs-5">5 Million characters</p>
              </div>

              {/* Features List */}
              <ul
                className="list-group list-group-flush bg-white"
                style={{ marginTop: "3rem" }}
              >
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Lifetime free
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Process total 50,00,000 (chars)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Words limit 7000 (at a time)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Fastest response time
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  No Advertisements
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  AI detection (Text + Image)
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  AI to Humanizer
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Paraphrase Texts
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Summarize Texts
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Plagiarism Checker
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Access to all premium features
                </li>
                <li className="list-group-item text-start ms-3">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  Browse History
                </li>
                <li className="list-group-item text-start ms-3 text-decoration-line-through">
                  <i
                    className="bi bi-check-circle-fill me-4"
                    style={{ color: "green" }}
                  ></i>
                  API usage
                  <span className="badge bg-secondary ms-3">Coming soon</span>
                </li>
              </ul>

              {/* Purchase Button */}
              <div>
                <button
                  className="btn btn-primary px-5 py-2 mb-4 mt-5 rounded-pill fs-5"
                  onClick={(e) => {
                    //analytics
                    logEvent(analytics, "button_click", {
                      button_name: "purchase_enterprise_click",
                    });
                    //blur
                    e.target.blur();
                    //selectedƒ
                    setItemsState({ ...itemsState, selected_index: 2 });
                    //navigate to purchase page
                    navigate("/purchase", {
                      state: {
                        item: itemsState.items[2],
                      },
                    }); //Navigate to purchase page
                  }}
                >
                  Purchase
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PricingBody;
